import React, { useContext, Fragment } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { AppContext } from "store/AppContext";


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  },
  titleSection: {
    textAlign: 'left',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: theme.spacing(2),
  },
  titleText: {
    textTransform: 'uppercase',
    borderBottom: '3px solid',
    borderBottomColor: theme.palette.primary.main,
  }
}));

const Profill = () => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const user = context.user.get.details;
  const roles = Array.isArray(user.role) ? user.role.filter(x => x.includes('utankjorfundarkerfi')) : [user.role];

  return (
    <Fragment>
      <Typography className={classes.titleSection} variant="h5" component="h2">
        <strong className={classes.titleText}>Upplýsingar um notanda</strong>
      </Typography>

      <Paper className={classes.paper}>
        <Typography>
          <strong>Nafn: </strong>
          {user.saml_username}
        </Typography>
        <Typography>
          <strong>Kennitala: </strong>
          {user.saml_userssn}
        </Typography>
        <Typography>
          <strong>Auðkenningaraðferð: </strong>
          {user.saml_authentication}
        </Typography>
        <Typography>
          <strong>Notendanúmer: </strong>
          {user.sub}
        </Typography>
        <Typography>
          <strong>Embættisnúmer: </strong>
          {user.embaettisnumer}
        </Typography>
        <Typography>
          <strong>Réttindi: </strong>
          {roles.map((role, i) => <span key={i}>{role + ', '}</span>)}
        </Typography>       
      </Paper>
    </Fragment>
  );
}

export default Profill;